module.exports = __webpack_public_path__ + "static/media/culinary.5124e5b3.svg";